<template>
    <el-select v-if="classInfo.cate == 2" size="small" placeholder="请选择课程" v-model="courseId" @change="courseChange">
        <el-option v-for="item in classInfo.courses" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
</template>

<script>
import { mapState } from 'vuex'
export default {
    data () {
        return {
            option: [],//课程选项
            courseId: this.$store.state.classInfo.course_id,
        }
    },
    computed: {
        ...mapState({
            class_id: state => state.class_id,
            classInfo: state => state.classInfo
        }),
    },
    mounted () {
        this.getCourseInfo()
    },
    methods: {
        // 获取课程信息
        async getCourseInfo () {
            const { data: res } = await this.$axios.post('base/class/list', {
                class_id: this.class_id,
            })

            if (res.errCode === 0) {
                const info = res.data.map(item => {
                    return {
                        course_id: item.course_id,
                        course_name: item.course_name
                    }
                })
                this.option = info

            }
        },
        courseChange () {
            this.$emit('courseChange', this.courseId)
        }
    }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/filterComponent/CourseSelect.vue